import {
    Component,
    ElementRef,
    Inject,
    OnInit,
    ViewChild,
    HostListener, 
    AfterViewInit,
    ChangeDetectorRef,
    OnDestroy
  } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/shared/shared.service';
import { tracking_response_Shipment_model } from '../../tracking-item/tracking-item.model';
import { TranslateService } from '@ngx-translate/core';
// import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { DialogData } from '../../tracking.module';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { interval, Subject, Observable, Subscription } from 'rxjs';
import { verify_otp_request_model, verify_otp_response_model, generate_otp_request_model, generate_otp_response_model} from '../../tracking-item/tracking-verify-phone-refund-dialog/tracking-verify-phone-refund-model';
@Component({
  selector: 'tracking-verify-phone-refund-dialog',
  templateUrl: 'tracking-verify-phone-refund-dialog.html',
  styleUrls: ['tracking-verify-phone-refund-dialog.scss'],
})

export class TrackingVerifyPhoneRefund implements OnInit, AfterViewInit, OnDestroy {
  
  @ViewChild('Text1') text1:ElementRef;
  @ViewChild('numInput1') numInput1: ElementRef;
  @ViewChild('numInput2') numInput2: ElementRef;
  @ViewChild('numInput3') numInput3: ElementRef;
  @ViewChild('numInput4') numInput4: ElementRef;
  @ViewChild('numInput5') numInput5: ElementRef;
  @ViewChild('numInput6') numInput6: ElementRef;
  @ViewChild('hd1') hd1: ElementRef;
  pattern = /[0-9a-zA-Z]/;
  allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
  countdownValue: number;
  intervalId: any;
  refPhone: any;
  isAccept: any ;
  constructor(
    public dialogRef: MatDialogRef<TrackingVerifyPhoneRefund>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private _HttpClient: HttpClient
  ) {}

  ngOnDestroy() {
    this.clearCountdown(); // เคลียร์ interval เมื่อ component ถูกทำลาย
  }
  
  ngOnInit(): void {
    this.isAccept = true;
    // this.refPhone = this.MarkMobile(this.data?.data?.shipment?.r_mobile, 4);
    // console.log('phone =>' +  this.refPhone);
    this.GenerateOTP(this.data).subscribe(
      (response:any)  => {
        if(!['th.kex-express.com','th.kerryexpress.com'].includes(window.location.hostname))
          {
            console.log('API Response:', JSON.stringify(response));
            this.refPhone = this.MarkMobile(this.data?.data?.shipment?.r_mobile, 4);
            console.log('phone =>' +  this.refPhone);
          }
        if (response.success) 
        {
          
          // alert('Submit Success.');
          if(response.otpData != null)
          {
            console.log(response.otpData.data + " | " + response.otpData.ttl);
            this.startCountdown(response.otpData.ttl);
          }
          else{
            this.startCountdown(180);
          }
        }
        else
        {
          alert('Generate Fail Error. '+ response.errorMessage);
          return;
        }
    });
   }

  ngAfterViewInit(): void {
    //console.log('action => : ' + this.data?.action)
    setTimeout(() => {
      this.numInput1.nativeElement.focus();
    }, 300);
    this.numInput1.nativeElement.style.border = "2px solid #F37021";
  }

  MarkMobile(mobile: string, ligitMark: number) {
    if(mobile != "" && mobile !== undefined && mobile != null)
      {
        let phoneMarking = "";
        for(let index =0; index < mobile.length; index++)
        {
          if(index == 3 || index == 6)
          {
            phoneMarking =  phoneMarking + ' ';
          }
          phoneMarking = phoneMarking + (index < mobile.length -ligitMark ? '*' : mobile[index])
          //console.log('mobile[index]' +mobile[index] +'] | index['+index+'] | phone =>' +  phoneMarking);
        } 
        mobile = phoneMarking;
      }

      return mobile;
  }
  
  startCountdown(startValue: number) {
    this.countdownValue = startValue;

    // ตั้ง interval เพื่อลดค่า countdownValue ทีละ 1 ทุกๆ 1 วินาที
    this.intervalId = setInterval(() => {
      this.countdownValue--;
      if (this.countdownValue <= 0) {
        this.clearCountdown();
      }
    }, 1000); // 1000 มิลลิวินาที = 1 วินาที
  }

  clearCountdown() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  phoneNumber: string;
  validateNumber(event: KeyboardEvent) {
    //const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    // console.log('validateNumber => '+ event.key);
    // console.log(!allowedKeys.includes(event.key));
    // console.log(!this.pattern.test(event.key));
    // console.log(!allowedKeys.includes(event.key) && this.pattern.test(event.key));
    if ((!this.allowedKeys.includes(event.key) && !this.pattern.test(event.key))) {
      event.preventDefault();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkAction(event: KeyboardEvent, currentIndex: number, prevIndex: number, nextIndex: number) {
    const num1Value = this.numInput1.nativeElement.value;
    const num2Value = this.numInput2.nativeElement.value;
    const num3Value = this.numInput3.nativeElement.value;
    const num4Value = this.numInput4.nativeElement.value;
    const num5Value = this.numInput5.nativeElement.value;
    const num6Value = this.numInput6.nativeElement.value;
    var verifyInput = num1Value+num2Value+num3Value+num4Value+num5Value+num6Value;
    const digitInput = verifyInput.length;
    const key = event.key;
    // console.log('checkAction => '+ key + ' | currentIndex => ' + currentIndex + ' | '+ this.pattern.test(key));
    // //const input = event.target as HTMLInputElement;
    // console.log((!this.allowedKeys.includes(key)));
    // console.log(this.pattern.test(key));
    // console.log(event.key.length != 1)
    if ((!this.allowedKeys.includes(key) && this.pattern.test(key) && event.key.length != 1)) {
     return event.preventDefault();
    }
    this.isAccept = true;
    if(currentIndex == 6)
      {
          if (key === 'Backspace') {
          var digit1 = verifyInput.substring(0,1);
          this.numInput1.nativeElement.value = digit1; 
          var digit2 = verifyInput.substring(1,2);
          this.numInput2.nativeElement.value = digit2;
          var digit3 = verifyInput.substring(2,3);
          this.numInput3.nativeElement.value = digit3; 
          var digit4 = verifyInput.substring(3,4); 
          this.numInput4.nativeElement.value = digit4;
          var digit5 = verifyInput.substring(4,5);
          this.numInput5.nativeElement.value = '';
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput5.nativeElement.focus();
                });
                //this.data.isVerify = true;
                this.numInput6.nativeElement.style.border = "2px solid #777";
        }else{
          console.log(verifyInput);
          this.VerifyOTP(verifyInput, this.data).subscribe(
            (response:any)  => {
              if(!['th.kex-express.com','th.kerryexpress.com'].includes(window.location.hostname))
                {
                  console.log('API Response:', JSON.stringify(response));
                }
              if (response.isVerifyCode) 
              {
                this.dialogRef.close(true);
                this.isAccept = true;
              }
              else
              {
                //alert('Submit Fail Error. '+ response.errorMessage);
                this.isAccept = false;
                //this.dialogRef.close(false);
                return;
              }
          });
    
        }
      }
      else if(currentIndex == 5){
        if (key === 'Backspace') {
          var digit1 = verifyInput.substring(0,1);
          this.numInput1.nativeElement.value = digit1; 
          var digit2 = verifyInput.substring(1,2);
          this.numInput2.nativeElement.value = digit2;
          var digit3 = verifyInput.substring(2,3);
          this.numInput3.nativeElement.value = digit3;  
          var digit4 = verifyInput.substring(3,4);
          this.numInput4.nativeElement.value = '';
          this.numInput5.nativeElement.value = '';
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput4.nativeElement.focus();
                });
                this.data.isVerify = true;
                this.numInput5.nativeElement.style.border = "2px solid #777";
        }
        else if(this.pattern.test(event.key)){
          var digit1 = verifyInput.substring(0,1);
          this.numInput1.nativeElement.value = digit1; 
          var digit2 = verifyInput.substring(1,2);
          this.numInput2.nativeElement.value = digit2;
          var digit3 = verifyInput.substring(2,3);
          this.numInput3.nativeElement.value = digit3;  
          var digit4 = verifyInput.substring(3,4);
          this.numInput4.nativeElement.value = digit4;
          this.numInput5.nativeElement.value = key;
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput6.nativeElement.focus();
                });
            this.numInput6.nativeElement.style.border = "2px solid #F37021";
        }
      }
      else if(currentIndex == 4){
        if (key === 'Backspace') {
          var digit1 = verifyInput.substring(0,1);
          this.numInput1.nativeElement.value = digit1; 
          var digit2 = verifyInput.substring(1,2);
          this.numInput2.nativeElement.value = digit2;
          var digit3 = verifyInput.substring(2,3);
          this.numInput3.nativeElement.value = '';  
          this.numInput4.nativeElement.value = '';
          this.numInput5.nativeElement.value = '';
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput3.nativeElement.focus();
                });
                this.data.isVerify = true;
                this.numInput4.nativeElement.style.border = "2px solid #777";
        }
        else if(this.pattern.test(event.key)){
          var digit1 = verifyInput.substring(0,1);
          this.numInput1.nativeElement.value = digit1; 
          var digit2 = verifyInput.substring(1,2);
          this.numInput2.nativeElement.value = digit2;
          var digit3 = verifyInput.substring(2,3);
          this.numInput3.nativeElement.value = digit3;  
          this.numInput4.nativeElement.value = key;
          this.numInput5.nativeElement.value = '';
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput5.nativeElement.focus();
                });
            this.numInput5.nativeElement.style.border = "2px solid #F37021";
        }
      }
    else if(currentIndex == 3){
      if (key === 'Backspace') {
        var digit1 = verifyInput.substring(0,1);
        this.numInput1.nativeElement.value = digit1; 
        var digit2 = verifyInput.substring(1,2);
        this.numInput2.nativeElement.value = '';
        this.numInput3.nativeElement.value = '';  
        this.numInput4.nativeElement.value = '';
        this.numInput5.nativeElement.value = '';
        this.numInput6.nativeElement.value = '';
        setTimeout(() => {
          this.numInput2.nativeElement.focus();
              });
              this.data.isVerify = true;
              this.numInput3.nativeElement.style.border = "2px solid #777";
      }
      else if(this.pattern.test(event.key)){
        var digit1 = verifyInput.substring(0,1);
        this.numInput1.nativeElement.value = digit1; 
        var digit2 = verifyInput.substring(1,2);
        this.numInput2.nativeElement.value = digit2;
        var digit3 = verifyInput.substring(2,3);
        this.numInput3.nativeElement.value = key;  
        this.numInput4.nativeElement.value = '';
        this.numInput5.nativeElement.value = '';
        this.numInput6.nativeElement.value = '';
        setTimeout(() => {
          this.numInput4.nativeElement.focus();
              });
          this.numInput4.nativeElement.style.border = "2px solid #F37021";
      }
    }
    else if(currentIndex == 2){
      if (key === 'Backspace') {
        var digit1 = verifyInput.substring(0,1);
          this.numInput1.nativeElement.value = ''; 
          this.numInput2.nativeElement.value = ''; 
          this.numInput3.nativeElement.value = '';  
          this.numInput4.nativeElement.value = '';
          this.numInput5.nativeElement.value = '';
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput1.nativeElement.focus();
                });
                this.data.isVerify = true;
                this.numInput2.nativeElement.style.border = "2px solid #777";
      }
      else if(this.pattern.test(event.key)){
        var digit1 = verifyInput.substring(0,1);
          this.numInput1.nativeElement.value = digit1; 
          var digit2 = verifyInput.substring(1,2);
          this.numInput2.nativeElement.value = key; 
          this.numInput3.nativeElement.value = '';  
          this.numInput4.nativeElement.value = '';
          this.numInput5.nativeElement.value = '';
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput3.nativeElement.focus();
                });
            this.numInput3.nativeElement.style.border = "2px solid #F37021";
      }
    }
    else{
      if (key === 'Backspace') {
          this.numInput1.nativeElement.value = ''; 
          this.numInput2.nativeElement.value = ''; 
          this.numInput3.nativeElement.value = '';  
          this.numInput4.nativeElement.value = '';
          this.numInput5.nativeElement.value = '';
          this.numInput6.nativeElement.value = '';
          setTimeout(() => {
            this.numInput1.nativeElement.focus();
                });
                this.data.isVerify = true;
                this.numInput2.nativeElement.style.border = "2px solid #777";
      }
      else if(this.pattern.test(event.key)){
          this.numInput1.nativeElement.value = key; 
          setTimeout(() => {
            this.numInput2.nativeElement.focus();
                });
            this.numInput2.nativeElement.style.border = "2px solid #F37021";
      }
    }
  }

  GenerateOTP(shipment : any): Observable<generate_otp_response_model> {
    //console.log('========= CallToKOP ==========')
    const requestData: generate_otp_request_model = {
      phone: shipment?.data?.shipment?.r_mobile,
      consignmentNo: shipment?.data?.shipment?.con,
    };

    if(!['th.kex-express.com','th.kerryexpress.com'].includes(window.location.hostname))
    {
      console.log('Request=> ' + JSON.stringify(requestData));
    }

    let url = ['th.kex-express.com','th.kerryexpress.com'].includes(window.location.hostname) ? `https://${window.location.hostname}` : 'https://poc-it.th.kex-express.com';
    url +=  '/track/api/Shipment/GenerateOTP';
    return this._HttpClient.post<generate_otp_response_model>(url, requestData);
  }

  VerifyOTP(verifyCode: any, shipment : any): Observable<verify_otp_response_model> {
    //console.log('========= CallToKOP ==========')
    const requestData: verify_otp_request_model = {
      phone: shipment?.data?.shipment?.r_mobile,
      consignmentNo: shipment?.data?.shipment?.con,
      verifyCode:verifyCode.toUpperCase()
    };

    if(window.location.hostname != 'th.kex-express.com')
    {
      console.log('Request=> ' + JSON.stringify(requestData));
    }

    let url = ['th.kex-express.com','th.kerryexpress.com'].includes(window.location.hostname) ? `https://${window.location.hostname}` : 'https://poc-it.th.kex-express.com';
    url +=  '/track/api/Shipment/VerifyOTP';
    return this._HttpClient.post<verify_otp_response_model>(url, requestData);
  }
}



